import * as Yup from "yup";
import axios from "axios";
import checkout from "./form";

const {
  formField: {
    name,
    description,
    role,
    partner,
    bio,
    languages,
    interests,
    destinations,
    // destinations,
    photo,
    phone,
    commission,
    balance,
    location,
    locations,
    email,
  },
} = checkout;

const URL = process.env.REACT_APP_API;

const emailCheckValidation = Yup.string()
  .email("Your email address is invalid!")
  .matches(/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/, "Your email address is invalid!")
  .required("Email address is required!")
  .test("checkEmailOnServer", "Email already Exists!", async function checkEmailOnServer(value) {
    if (!value) return true;
    const original = this.parent.originalEmail;
    // If user hasn't changed the name from the original, skip the server check
    if (value === original) {
      return true;
    }
    try {
      await axios.post(`${URL}/users/checkEmail`, { email: value });
      return true;
    } catch (err) {
      const msg = err?.response?.data?.msg || "Email already Exists!";
      return this.createError({ message: msg });
    }
  });

const validations = [
  Yup.object().shape({
    [name.name]: Yup.string()
      .matches(/([A-Za-z])/, name.invalidMsg)
      .required(name.errorMsg),
    // [role.name]: Yup.string().required(role.errorMsg),
    [phone.name]: Yup.string().matches(
      /^(\+|00)[0-9 ]{1,3}[0-9 ]{4,14}(?:x.+)?$/,
      phone.invalidMsg
    ),
    originalEmail: Yup.string().nullable(),
    [email.name]: emailCheckValidation,
  }),
  Yup.object().shape({
    [partner.name]: Yup.lazy((value) => {
      if (typeof value === "string") {
        return Yup.string().required("Partner is required!");
      }
      if (typeof value === "object" && value !== null) {
        return Yup.object({
          name: Yup.string().required("Partner name is required!"),
        });
      }

      // Handle other cases if needed
      return Yup.mixed().required("Partner is required!");
    }),
    [locations?.name]: Yup.array().when(["partnerPower", "allLocations"], {
      is: (partnerPower, allLocations) => partnerPower === true && allLocations === false,
      then: () => Yup.array().min(1, locations?.errorMsg).required(locations?.errorMsg),
    }),
    // [locations?.name]: Yup.array().when("allLocations", {
    //   is: false,
    //   then: () => Yup.array().min(1, locations?.errorMsg).required(locations?.errorMsg),
    // }),
    [role.name]: Yup.string().required(role.errorMsg),
  }),
  Yup.object().shape({
    [role.name]: Yup.string().required(role.errorMsg),
    [description.name]: Yup.string().required(description.errorMsg),
    [bio.name]: Yup.string().required(bio.errorMsg),
    [interests.name]: Yup.array().min(1, interests.errorMsg).required(),
    [languages.name]: Yup.array().min(1, languages.invalidMsg).required(),
    [destinations.name]: Yup.array().min(1, destinations.errorMsg).required(),

    [photo.name]: Yup.string().required(photo.errorMsg).nullable(),
  }),
  Yup.object().shape({
    locDestinations: Yup.object().shape(
      {
        location: Yup.mixed().when("destinations", {
          is: (desName) =>
            !desName ||
            (Array.isArray(desName) && desName.length === 0) ||
            (typeof desName === "string" && desName.trim() === "") ||
            (typeof desName === "object" && Object.keys(desName).length === 0),
          then: () =>
            Yup.mixed()
              .test(
                "is-valid-location",
                location.errorMsg,
                (value) =>
                  (typeof value === "object" && Object.keys(value).length > 0) ||
                  (typeof value === "string" && value.trim() !== "")
              )
              .required(location.errorMsg),
        }),
        destinations: Yup.mixed().when("location", {
          is: (loc) =>
            !loc ||
            (typeof loc === "object" && Object.keys(loc).length === 0) ||
            (typeof loc === "string" && loc.trim() === ""),
          then: () =>
            Yup.mixed()
              .test("is-valid-destination", destinations.errorMsg, (value) =>
                Array.isArray(value)
                  ? value.length > 0
                  : (typeof value === "string" && value.trim() !== "") ||
                    (typeof value === "object" && Object.keys(value).length > 0)
              )
              .required(destinations.errorMsg),
        }),
      },
      ["destinations", "location"]
    ),

    [balance.name]: Yup.number()
      .min(0, "Initial balance must be at least 0")
      .required(balance.errorMsg),
    [commission.name]: Yup.number()
      .min(0, "Commission must be between 0 and 50")
      .max(50, "Commission must be between 0 and 50")
      .required(commission.errorMsg),
  }),
];

export default validations;
